import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Loja online',
        [PolygraphyProductUrlType.Storefront]: 'Montra',
        [PolygraphyProductUrlType.Custom]: 'Personalizado',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Guarde as alterações para ver a pré-visualização',
  },
  buttons: {
    save_and_preview: 'Guardar e pré-visualizar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o produto',
    failed_to_save_changes: 'Falha ao guardar as alterações!',
    changes_got_saved: 'Alterações guardadas!',
  },
};
